import ReviewCard from '@/components/base/ReviewCard';
import { userReviews } from '@/mocks/home';

export default function UserReviews() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="text-center mb-10 md:mb-14">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            <span className="text-xs font-semibold text-primary-500 tracking-wider uppercase">读者口碑</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-900">
            他们都在韩漫网
          </h2>
          <p className="mt-2 text-sm text-foreground-500">听听读者们怎么说</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {userReviews.slice(0, 6).map((review, index) => (
            <div key={index} className={index >= 5 ? 'opacity-60' : ''}>
              <ReviewCard {...review} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}